import React from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * EditorNotification — Snackbar/Alert for save confirmations and errors.
 */
const EditorNotification = ({ notification, onClose }) => {
  const { open, message, severity } = notification || {};

  return (
    <Snackbar
      open={!!open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={severity || 'info'} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default EditorNotification;
